import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const navigation = {
  solutions: [
    { name: "Marketing", href: "/services/marketing" },
    { name: "Web Development", href: "/services/web_development" },
  ],
  support: [
    { name: "Guides", href: "/guides" },
    { name: "Blog", href: "/blog" },
  ],
  company: [
    { name: "Contact", href: "/contact" },
    { name: "About Us", href: "/about_us" },
  ],
  legal: [
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
  ],
  social: [
    {
      name: "GitHub",
      icon: (props) => <i className="bx bxl-github text-2xl"></i>,
    },
    {
      name: "YouTube",
      icon: (props) => <i className="bx bxl-youtube text-2xl"></i>,
    },
  ],
};

function Footer() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "" });
  const { email } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const formData = new FormData();
    formData.append("email", email);

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/contacts/newsletter`, formData, config)
      .then((res) => {
        toast.success("Thank you for subscribing!");
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Error sending message");
      });
  };

  return (
    <footer className="bg-gray-50 dark:bg-dark-bg" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="grid grid-cols-2 gap-8 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-gilroy-semibold text-gray-300 tracking-wider uppercase">Services</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.solutions.map((item) => (
                    <li key={item.name}>
                      <NavLink to={item.href} className="text-base text-gray-400 hover:text-gray-500 font-gilroy-regular">
                        {item.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-gilroy-semibold text-gray-300 tracking-wider uppercase">Support</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.support.map((item) => (
                    <li key={item.name}>
                      <NavLink to={item.href} className="text-base text-gray-400 hover:text-gray-500 font-gilroy-regular">
                        {item.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-gilroy-semibold text-gray-300 tracking-wider uppercase">Company</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <NavLink to={item.href} className="text-base text-gray-400 hover:text-gray-500 font-gilroy-regular">
                        {item.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-gilroy-semibold text-gray-300 tracking-wider uppercase">Legal</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.legal.map((item) => (
                    <li key={item.name}>
                      <NavLink to={item.href} className="text-base text-gray-400 hover:text-gray-500 font-gilroy-regular">
                        {item.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-8 xl:mt-0">
            <h3 className="text-sm font-gilroy-semibold text-gray-300 tracking-wider uppercase">
              Discount Coupons & Free Training!
            </h3>
            <p className="mt-4 text-base text-gray-400">
              Discounts, important news, training, and much more!
            </p>
            <form onSubmit={onSubmit} className="mt-4 sm:flex sm:max-w-md">
              <input
                type="email"
                name="email"
                value={email}
                onChange={onChange}
                autoComplete="email"
                required
                className="appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-xl shadow-sm py-2 px-4 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:placeholder-gray-400"
                placeholder="Enter your email"
              />
              <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                <button
                  type="submit"
                  className="w-full bg-blue-600 flex items-center justify-center border border-transparent rounded-xl py-2 px-4 text-base font-gilroy-medium text-white hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Subscribe
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
